import { TFunction } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';
import { RatingLabelComponent } from '@/types/schema';

export const DEFAULT_LIKERT_LABEL_CONFIG = [
  { labelKey: 'UserSurvey:Creator.StronglyDisagree', value: 1 },
  { labelKey: 'UserSurvey:Creator.Disagree', value: 2 },
  { labelKey: 'UserSurvey:Creator.Neutral', value: 3 },
  { labelKey: 'UserSurvey:Creator.Agree', value: 4 },
  { labelKey: 'UserSurvey:Creator.StronglyAgree', value: 5 },
];

const renderMarkLabel = (label: string) => {
  return (
    <Typography
      className="whitespace-normal text-center"
      color="text-text-secondary"
      variant="body-short-02">
      {label}
    </Typography>
  );
};

export const getSliderMarks = (t: TFunction, ratingLabels?: RatingLabelComponent[]) => {
  if (ratingLabels) {
    return ratingLabels.map(({ labelName, rating }) => ({
      value: rating!,
      label: labelName,
    }));
  }

  return DEFAULT_LIKERT_LABEL_CONFIG.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
};

export const getRenderedSliderMarks = (t: TFunction, ratingLabels?: RatingLabelComponent[]) => {
  return getSliderMarks(t, ratingLabels).map(({ value, label }) => ({
    value,
    label: renderMarkLabel(label),
  }));
};
